import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";

import { API_ENDPOINT } from "../../config";
import { ListResponse, Tag } from "../../interfaces";
import { toastMessage } from "../../utils/toastError";
import { TagType } from "../../interfaces";

export const tagApi = createApi({
  reducerPath: "tagApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_ENDPOINT + "/tag",
    credentials: "include",
  }),
  endpoints: (build) => ({
    getAllTags: build.query<ListResponse<Tag>, { type?: TagType } | void>({
      query: (params) => ({
        url: "",
        method: "GET",
        params: params ? params : {},
      }),
    }),
    createTag: build.mutation<Tag, { name: string; type?: TagType }>({
      query: (payload) => ({
        url: "",
        method: "POST",
        body: payload,
      }),
      transformErrorResponse(baseQueryReturnValue) {
        toastMessage("error", baseQueryReturnValue.data);
        return Promise.resolve(baseQueryReturnValue.data);
      },
      transformResponse(baseQueryReturnValue: Tag) {
        toastMessage("success", "Successfully created");
        return baseQueryReturnValue;
      },
    }),
    updateTag: build.mutation<Tag, { id: string; name: string }>({
      query: (payload) => ({
        url: "",
        method: "PUT",
        body: payload,
      }),
      transformErrorResponse(baseQueryReturnValue) {
        toastMessage("error", baseQueryReturnValue.data);
        return Promise.reject(baseQueryReturnValue.data);
      },
      transformResponse(baseQueryReturnValue: Tag) {
        toastMessage("success", "Successfully updated");
        return baseQueryReturnValue;
      },
    }),
    deleteTag: build.mutation<Tag, { id: string }>({
      query: (payload) => ({
        url: "",
        method: "DELETE",
        body: payload,
      }),
      transformErrorResponse(baseQueryReturnValue) {
        toastMessage("error", baseQueryReturnValue.data);
        return Promise.reject(baseQueryReturnValue.data);
      },
      transformResponse(baseQueryReturnValue: Tag) {
        toastMessage("success", "Successfully deleted");
        return baseQueryReturnValue;
      },
    }),
  }),
});

export const {
  // Tags
  useGetAllTagsQuery,
  useCreateTagMutation,
  useUpdateTagMutation,
  useDeleteTagMutation,
} = tagApi;
